import { PageContainer, ProTable } from '@ant-design/pro-components';
import { queryTraceContentLogs } from '../services/trace';

const columns = [
  {
    title: '组织ID',
    dataIndex: 'organizationId',
    copyable: true,
  },
  {
    title: '账号类型',
    dataIndex: 'accountType',
  },
  {
    title: '平台',
    dataIndex: 'platform',
  },
  {
    title: '账号ID',
    dataIndex: 'accountId',
    copyable: true,
  },
  {
    title: '内容ID',
    dataIndex: 'contentId',
    copyable: true,
  },
  {
    title: '内容标题',
    dataIndex: 'title',
  },
  {
    title: '获赞数',
    dataIndex: 'likeCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '评论数',
    dataIndex: 'commentCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '转发数',
    dataIndex: 'shareCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '收藏数',
    dataIndex: 'collectCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '视频地址',
    dataIndex: 'videoUrl',
    copyable: true,
    search: false,
    ellipsis: true,
  },
  {
    title: '记录时间',
    dataIndex: 'createdAt',
    valueType: 'dateTime',
    search: false,
  },
];

const ContentLogs = () => (
  <PageContainer content="厂商管理员在这里查看内容维度的监测日志。">
    <ProTable
      rowKey="id"
      headerTitle="内容日志"
      request={queryTraceContentLogs}
      columns={columns}
      search={{
        labelWidth: 96,
      }}
      scroll={{
        x: 'max-content',
      }}
    />
  </PageContainer>
);

export default ContentLogs;
